import type { ElementStyle } from "@mm/metx-workbench.meteomatics.com";
import type { CSSProperties } from "react";

export function convertToCSSProperties(style?: ElementStyle | null): CSSProperties | undefined {
  if (!style) {
    return undefined;
  }

  const { color, fontSize, fontWeight, fontStyle, textDecoration } = style;

  return {
    ...(color != null && { color }),
    ...(fontSize != null && { fontSize }),
    ...(fontWeight != null && { fontWeight }),
    ...(fontStyle != null && { fontStyle }),
    ...(textDecoration != null && { textDecoration }),
  };
}

const elementStyleBase = {
  color: null,
  fontSize: null,
  fontWeight: null,
  fontStyle: null,
  textDecoration: null,
};

export function createElementStyle(style: Partial<ElementStyle>): ElementStyle {
  return {
    ...elementStyleBase,
    ...style,
  };
}
